import { User } from "../types/UserTypes";

class LocalStorageService {
  private readonly USER_KEY = 'USER';

  set user(user: User | null) {
    if (user) {
      localStorage.setItem(this.USER_KEY, JSON.stringify(user));
    } else {
      this.removeUser();
    }
  }

  get user(): User | null {
    const userData = localStorage.getItem(this.USER_KEY);
    return userData ? JSON.parse(userData) : null;
  }

  getUserOrThrow(): User  {
    if (!this.user) {
      throw new Error('User not set');
    }

    return this.user;
  }

  removeUser(): void {
    localStorage.removeItem(this.USER_KEY);
  }

  clear(): void {
    localStorage.clear();
  }

}

export const localStorageService = new LocalStorageService();